import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';

// 获取prop值（defineProps）

export default /*#__PURE__*/_defineComponent({
  __name: 'k2-tooltip',
  props: {
  // tooltip的显示值
  title:{
    type: [String,Number],
    required: false,
    default:''
  },
  // 打开方向
  placement:{
    type: String,
    required: false,
    default:'topLeft'
  },
  // 触发行为，可选 hover/focus/click/contextmenu
  trigger: {
    type: String,
    required: false,
    default: 'hover'
  },
  overlayClassName: {
    type: String,
    required: false,
    default: 'custom-tooltip'
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;


const isShow = ref(false)
const showToolTip = (e: any) => {
  if (e.target.clientWidth >= e.target.scrollWidth) {
    isShow.value = false;
  } else {
    isShow.value = true;
  }
}
const closeToolTip = () => {
  isShow.value = false;
}

const __returned__ = { props, isShow, showToolTip, closeToolTip }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})